import {Routes} from '@angular/router';
import {InitComponent} from './features/init/init.component';
import {LandingComponent} from './features/landing/landing.component';
import {ThankYouComponent} from './features/thank-you/thank-you.component';
import {NotFoundComponent} from "./features/not-found/not-found.component";
import {UploadDocumentComponent} from "./features/upload-document/upload-document.component";

export const routes: Routes = [
    {
        path: '',
        component: InitComponent
    },
    {
        path: 'landing',
        component: LandingComponent
    },
    {
        path: 'not-found',
        component: NotFoundComponent
    },
    {
        path: 'upload-document',
        component: UploadDocumentComponent
    },
    {
        path: 'thank-you',
        component: ThankYouComponent
    }
];
